import { Component, OnInit } from '@angular/core';
import {EnvironmentService} from '@utils/services/environment/environment.service';
import {GetAppDialogComponent} from '@shared/modules/shared-dialogs/dialogs/get-app-dialog/get-app-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ColorScheme} from '@lib/models/color-scheme/color-scheme';
import {MatchService} from '@lib-modules/match/services/match/match.service';

@Component({
  selector: 'lib-match-betting-game',
  templateUrl: './match-betting-game.component.html',
  styleUrls: ['./match-betting-game.component.scss']
})
export class MatchBettingGameComponent implements OnInit {

  constructor(public dialog: MatDialog,
              public matchService: MatchService) { }

  ngOnInit(): void { }

  public get colorScheme(): ColorScheme {
    return EnvironmentService.isWebsite ? ColorScheme.Dark : ColorScheme.Light;
  }

  public onClick() {
    this.dialog.open(GetAppDialogComponent, GetAppDialogComponent.getDialogSize());
  }
}
